import type { RendererProps } from "../types";

import { MediaPreviewCarousel } from "./MediaPreviewCarousel";

import type { MediaPayload } from "@/routes/smart-table/utils/contentType";

export function MediaRenderer({ content }: RendererProps) {
  const media = content.mediaPayload as MediaPayload | undefined;

  if (!media) {
    return null;
  }

  return <MediaPreviewCarousel items={[media]} />;
}
